<template>
    <div>
        <v-app-bar app clipped-right dark height="40px"
                   style="z-index: 99;"
                   v-bind="$attrs">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title>
                <span style="font-size:16px">入出荷検品システム</span>
                <span style="font-size:24px;font-weight:600" class="ml-8">{{ title }}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon
                           v-bind="attrs"
                           v-on="on"
                           color="white"
                           @click="Logout">
                        <v-icon>mdi-logout-variant</v-icon>
                    </v-btn>
                </template>
                <span>ログアウト</span>
            </v-tooltip>
        </v-app-bar>
        <v-navigation-drawer v-model="drawer" fixed
                             style="padding-top:80px; z-index: 98;">
            <v-row class="mx-3">
                <v-btn block tile x-large outlined text
                       @click="changePage('nyuka')">
                    <v-avatar size="35" color="nyuka" class="mr-3">
                        <v-icon color="white">
                            mdi-checkbox-outline
                        </v-icon>
                    </v-avatar>

                    入荷管理
                    <v-spacer />
                </v-btn>
            </v-row>
            <v-row class="ma-3">
                <v-btn block tile x-large outlined text
                       @click="changePage('syukka')">
                    <v-avatar size="35" color="syukka" class="mr-3">
                        <v-icon color="white">
                            mdi-package-variant-closed
                        </v-icon>
                    </v-avatar>
                    出荷管理
                    <v-spacer />
                </v-btn>
            </v-row>
            <v-row class="mx-3">
                <v-btn block tile x-large outlined text
                       @click="changePage('tanaoroshi')">
                    <v-avatar size="35" class="mr-3" color="tana">
                        <v-icon color="white">
                            mdi-file-document-outline
                        </v-icon>
                    </v-avatar>
                    棚卸管理
                    <v-spacer />
                </v-btn>
            </v-row>

            <v-row class="ma-3">
                <v-btn block tile x-large outlined text
                       @click="changePage('centernyuko')">
                    <v-avatar size="35" class="mr-3" color="centernyuko">
                        <v-icon color="white">
                            mdi-arrow-left-bold-box-outline
                        </v-icon>
                    </v-avatar>
                    <span style="font-size:14px" class="mr-n2">センター間入庫管理</span>
                    <v-spacer />
                </v-btn>
            </v-row>

            <v-row class="mx-3">
                <v-btn block tile x-large outlined text
                       @click="changePage('centersyukko')">
                    <v-avatar size="35" class="mr-3" color="centersyukko">
                        <v-icon color="white">
                            mdi-arrow-right-bold-box-outline
                        </v-icon>
                    </v-avatar>
                    <span style="font-size:14px" class="mr-n2">センター間出庫管理</span>
                    <v-spacer />
                </v-btn>
            </v-row>

            <v-row class="ma-3">
                <v-menu open-on-hover offset-x rounded="0">
                    <template v-slot:activator="{on}">
                        <v-btn v-on="on" block tile x-large outlined text>
                            <v-icon left color="grey darken-1" class="ml-3">mdi-menu-right</v-icon>
                            <span style="font-size:14px" class="ml-3">予定取込</span>
                            <v-spacer />
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item v-on:click="importData('RECEIVE')">
                            <v-list-item-content>
                                <v-list-item-title>入荷予定取込</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-on:click="importData('SHIP')">
                            <v-list-item-content>
                                <v-list-item-title>出荷予定取込</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-on:click="importData('INVENTORY')">
                            <v-list-item-content>
                                <v-list-item-title>理論在庫取込</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-on:click="importData('MOVE_RECEIVE')">
                            <v-list-item-content>
                                <v-list-item-title>センター間入庫予定取込</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-on:click="importData('MOVE_SHIP')">
                            <v-list-item-content>
                                <v-list-item-title>センター間出庫予定取込</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>

            </v-row>

            <v-row class="mx-3">
                <v-menu open-on-hover offset-x rounded="0">
                    <template v-slot:activator="{on}">
                        <v-btn v-on="on" block tile x-large outlined text>
                            <v-icon left color="grey darken-1" class="ml-3">mdi-menu-right</v-icon>
                            <span style="font-size:14px" class="ml-3">業務完了</span>
                            <v-spacer />
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item v-on:click="WorkDone('RECEIVE')">
                            <v-list-item-content>
                                <v-list-item-title>入荷業務完了</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-on:click="WorkDone('SHIP')">
                            <v-list-item-content>
                                <v-list-item-title>出荷業務完了</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-on:click="WorkDone('INVENTORY')">
                            <v-list-item-content>
                                <v-list-item-title>棚卸業務完了</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-on:click="WorkDone('MOVE_RECEIVE')">
                            <v-list-item-content>
                                <v-list-item-title>センター間入庫業務完了</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-on:click="WorkDone('MOVE_SHIP')">
                            <v-list-item-content>
                                <v-list-item-title>センター間出庫業務完了</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>

            </v-row>

            <v-row class="ma-3">
                <v-menu open-on-hover offset-x rounded="0">
                    <template v-slot:activator="{on}">
                        <v-btn v-on="on" block tile x-large outlined text>
                            <v-icon left color="grey darken-1" class="ml-3">mdi-menu-right</v-icon>
                            <span style="font-size:14px" class="ml-3">マスタ取込</span>
                            <v-spacer />
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item v-on:click="importData('PERSON')">
                            <v-list-item-content>
                                <v-list-item-title>担当者マスタ</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-on:click="importData('LOCATION')">
                            <v-list-item-content>
                                <v-list-item-title>ロケーションマスタ</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-on:click="importData('PRODUCT')">
                            <v-list-item-content>
                                <v-list-item-title>ラベル発行用商品マスタ</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-row>

            <v-row class="mx-3">
                <v-menu open-on-hover offset-x rounded="0">
                    <template v-slot:activator="{on}">
                        <v-btn v-on="on" block tile x-large outlined text>
                            <v-icon left color="grey darken-1" class="ml-3">mdi-menu-right</v-icon>
                            <span style="font-size:14px" class="ml-3">ツール</span>
                            <v-spacer />
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item v-on:click="changePage('resultexport')">
                            <v-list-item-content>
                                <v-list-item-title>実績データ出力</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-on:click="dataRemove('SHIP','PRSr')">
                            <v-list-item-content>
                                <v-list-item-title>出荷データクリア</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-row>
            <v-subheader>Ver - {{ appVersion }}</v-subheader>
        </v-navigation-drawer>

        <v-overlay :value="$store.state.master.is_loading" style="z-index:999">
            <v-progress-circular indeterminate
                                 size="64"></v-progress-circular>
        </v-overlay>

        
        <input style="display: none"
               ref="input_location"
               type="file"
               @change="selectedFile('ImportLocation')">
    </div>
</template>
<script>

    export default {
        components: {
        },
        props: {
            title: { type: String, default: '' },
            master: { type: Object, default: null },
            is_loading: { type: Boolean, require: false, 'default': false }
        },
        computed: {
            progressValue() {
                return Math.ceil(this.master.loaded_cnt / this.master.master_cnt * 100);
            }
        },
        data: () => ({
            drawer: false,
            appVersion: g_version,
            model: {
            },
        }),
        methods: {

            changePage(page) {

                if (this.url === page) {
                    console.log('遷移しない');
                    return;
                }

                window.location.href = '/' + page;
            },

            async importData(request) {
                var message = '';
                switch (request) {
                    case 'RECEIVE':
                        message = '入荷予定';
                        break;
                    case 'SHIP':
                        message = '出荷予定';
                        break;
                    case 'INVENTORY':
                        message = '理論在庫';
                        break;
                    case 'MOVE_RECEIVE':
                        message = 'センター間入庫予定';
                        break;
                    case 'MOVE_SHIP':
                        message = 'センター間出庫予定';
                        break;
                    case 'PERSON':
                        message = '担当者マスタ';
                        break;
                    case 'PRODUCT':
                        message = '商品マスタ';
                        break;
                    default:
                        break;
                }
                const con = await this.msg_confirm(`${message}取込を実行します。よろしいですか？`);
                if (!con) {
                    return;
                }
                try {
                    this.Loading(true);
                    var params = new URLSearchParams();
                    params.append('param', JSON.stringify(request));

                    let res = await this.axios_post(`/Interface/importData`, params);
                    if (res.data.status != "OK") {
                        this.msg_error_dialog(res.data.messages);
                        return;
                    }

                    if (res.plan_count > 0) {
                        this.notify_info(res.data.upd_count + " 件のデータを上書き取込みました");
                    }
                    else {
                        this.notify_info(res.data.upd_count + " 件のデータを取込みました");
                    }
                    
                    this.$emit('Reload')
                    
                } finally {
                    this.Loading(false);
                }

            },

            async WorkDone(request) {
                var message = '';
                switch (request) {
                    case 'RECEIVE':
                        message = '入荷';
                        break;
                    case 'SHIP':
                        message = '出荷';
                        break;
                    case 'INVENTORY':
                        message = '棚卸';
                        break;
                    case 'MOVE_RECEIVE':
                        message = 'センター間入庫';
                        break;
                    case 'MOVE_SHIP':
                        message = 'センター間出庫';
                        break;
                    default:
                        break;
                }
                const con = await this.msg_confirm(`${message}業務確定を実行します。よろしいですか？`);
                if (!con) {
                    return;
                }
                try {
                    this.Loading(true);
                    var params = new URLSearchParams();
                    params.append('param', JSON.stringify(request));

                    let res = await this.axios_post(`/Interface/WorkDone`, params);
                    if (res.data.status != "OK") {
                        this.msg_error_dialog(res.data.messages);
                        return;
                    }
                    this.notify_info("業務確定しました");
                    this.$emit('Reload')
                } finally {
                    this.Loading(false);
                }

            },

            async dataRemove(request,mode) {
                var message = '';
                switch (request) {
                    case 'RECEIVE':
                        message = '入荷';
                        break;
                    case 'SHIP':
                        message = '出荷';
                        break;
                    case 'INVENTORY':
                        message = '在庫';
                        break;
                    case 'MOVE_RECEIVE':
                        message = 'センター間入庫';
                        break;
                    case 'MOVE_SHIP':
                        message = 'センター間出庫';
                        break;
                    case 'PERSON':
                        message = '担当者';
                        break;
                    case 'PRODUCT':
                        message = '商品';
                        break;
                    default:
                        break;
                }
                const con = await this.msg_confirm(`${message}データの削除を実行します。よろしいですか？`);
                if (!con) {
                    return;
                }
                try {
                    this.Loading(true);
                    var params = new URLSearchParams();
                    params.append('param', JSON.stringify(request));
                    params.append('paramMode', JSON.stringify(mode));

                    let res = await this.axios_post(`/Interface/dataRemove`, params);

                    if (res.data.status != "OK") {
                        this.msg_error_dialog(res.data.messages);
                        return;
                    }
                    if (res.data.error_msg != "") {
                        this.msg_error_dialog(res.data.error_msg);
                        return;
                    }

                    if (res.data.plan_count != 0) {
                        this.notify_info(`${res.data.plan_count}件 ${message}予定データを削除しました。`);
                    }
                    if (res.data.result_count != 0) {
                        this.notify_info(`${res.data.result_count}件 ${message}実績データを削除しました。`);
                    }
                    if (res.data.result_history_count != 0) {
                        this.notify_info(`${res.data.result_history_count}件 ${message}実績履歴データを削除しました。`);
                    }
                    if (res.data.sum_result_count != 0) {
                        this.notify_info(`${res.data.sum_result_count}件 ${message}集約実績データを削除しました。`);
                    }
                    if (res.data.sum_result_history_count != 0) {
                        this.notify_info(`${res.data.sum_result_history_count}件 ${message}集約実績履歴データを削除しました。`);
                    }
                    
                    this.$emit('Reload')

                } finally {
                    this.Loading(false);
                }

            },

            Logout: function (page) {

                if (this.url == page) {
                    console.log('遷移しない');
                    return;
                }
                window.location.href = '/Login/Logout';
            },
        }

    };
</script>

<style scoped>
    .v-navigation-drawer--absolute {
        z-index: 4 !important;
    }
</style>
